export default "__VITE_ASSET__Cgp4P9qr__"